






























































































































































































































































































































































































import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  nextTick,
} from '@vue/composition-api';
import * as echarts from 'echarts';
import { Message } from 'element-ui';
import QRCode from 'qrcodejs2';

import valueToLabel from '@utils/valueToLabel';
import svgCom from '@components/Svg/index';
import request from '@utils/request';
import { userInfor as userInfoRef } from '@/useable/login';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'DataFinancingApply',
  components: {
    svgCom,
    QRCode,
  },
  setup() {
    const state = reactive({
      checkedBank: '',
      socialCreditCode: '',
      scoreUpdateTime: '',
      totalScore: null,
      dataList: {},
      dialogVisible: false,
      dialogMsg: '',
      dialogTipShow: true,
      dialogType: '',
      financingUrl: '',
      qrcode: null,
      applyInfos: [
        {
          bankCode: 'CMB',
          bizStatus: 'P',
          loginUrl: '',
          processMsg: '',
          threshold: '',
        },
        {
          bankCode: 'CCB',
          bizStatus: 'P',
          loginUrl: '',
          processMsg: '',
          threshold: '',
        },
        {
          bankCode: 'SPD',
          bizStatus: 'P',
          loginUrl: '',
          processMsg: '',
          threshold: '',
        },
        {
          bankCode: 'PINGAN',
          bizStatus: 'P',
          loginUrl: '',
          processMsg: '',
          threshold: '',
        },
      ],
    });
    const option = {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 800,
          progress: {
            show: true,
            width: 0,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#A3FB7C', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#ED4838', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          axisLine: {
            lineStyle: {
              width: 0,
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            distance: 36,
            length: 8,
            lineStyle: {
              width: 2,
              color: '#999',
            },
          },
          axisLabel: {
            distance: 5,
            color: '#999',
            fontSize: 14,
            formatter(v) {
              // 只显示数字0和1000
              if (v === 0) {
                return '0';
              }
              if (v === 800) {
                return '800';
              }
            },
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 10,
            itemStyle: {
              borderWidth: 2,
            },
          },
          pointer: {
            show: true,
            width: 10,
            itemStyle: {
              color: '#000',
            },
          },

          title: {
            offsetCenter: [0, '88%'],
            fontSize: 15,
          },
          detail: {
            valueAnimation: true,
            // fontSize: `${!!state.dataList ? 24 : 14}`,
            offsetCenter: [0, '64%'],
            // color: `${!!state.dataList ? '#FF5C5C' : '#CFCFCF'}`,
            // fontWeight: state.dataList ? 'bold' : 'normal',
            fontSize: 30,
            color: '#FF5C5C',
            fontWeight: 'bold',
            formatter(value) {
              return value || value === 0 ? value : '暂无评分';
            },
          },
          data: [
            {
              value: '0',
              name: '企业合作分',
            },
          ],
        },
      ],
    };

    const statusToColor = {
      P: {
        color: '#4C4C4C',
        background: '#F8F8F8',
      },
      R: {
        color: '#3A84FB',
        background: '#F0F6FF',
      },
      FAILED: {
        color: '#FF5C5C',
        background: '#FFEEEE',
      },
      wdb: {
        color: '#FFAC15',
        background: '#FFF7E9',
      },
    };

    // 页面初始化
    const init = async () => {
      const params = {
        vendorName: userInfor.supplierName,
        current: 1,
        pageSize: 10,
      };
      const res = await request('dataFinancing', 'getScoreList', params);
      if (res.code === 2000) {
        state.dataList = res.data.dataList?.[0];
        state.applyInfos = state.applyInfos.map((itemA) => {
          const itemB =
            state.dataList &&
            (state.dataList as any).applyInfos.find(
              b => b.bankCode === itemA.bankCode,
            );
          return itemB ? itemB : itemA;
        });
        state.applyInfos.map((i) => {
          const thresholdItem = (state.dataList as any)?.thresholds.find(
            b => b.bankCode === i.bankCode,
          );
          if (thresholdItem) {
            i.threshold = thresholdItem.threshold;
          }
          return;
        });
        option.series[0].data[0].value = state.totalScore = state.dataList
          ? (state.dataList as any).totalScore
          : null;
        state.scoreUpdateTime =
          state.dataList && (state.dataList as any).dataDate;
        state.socialCreditCode =
          state.dataList && (state.dataList as any).socialCreditCode;
      }
      nextTick(() => {
        if (!state.dataList) {
          option.series[0].detail.fontSize = 14;
          option.series[0].detail.color = '#CFCFCF';
          option.series[0].detail.fontWeight = 'normal';
        }
        initChart();
      });
    };

    // 图表初始化
    const initChart = () => {
      const chartDom: any = document.getElementById('gauge-chart');

      const myChart = echarts.init(chartDom);
      option && myChart.setOption(option);
    };

    const createQrcode = (it) => {
      if (it.loginUrl && it.bankCode === 'CMB') {
        setTimeout(() => {
          const qrcodeDom: any = document.getElementById('qrcode');
          if (state.qrcode && qrcodeDom) {
            qrcodeDom.innerHTML = '';
          }
          state.qrcode = new QRCode(qrcodeDom, {
            width: 70,
            height: 70,
            text: it.loginUrl,
          });
        }, 200);
      }
    };

    // 切换银行
    // const toggleCard = (index: number) => {
    //   option.series[0].data[0].value =
    //     (state.dataList[index] as any).totalScore || 0;
    //   state.scoreUpdateTime = (state.dataList[index] as any).dataDate;
    //   initChart();
    // };

    // 前往申请
    const applySubmit = async () => {
      if (typeof state.checkedBank !== 'number') {
        Message.error('请选择银行');
        return;
      }
      state.dialogVisible = true;
      state.dialogTipShow = true;
      state.dialogType = 'apply';
      state.dialogMsg =
        '银行完成供应商融资评估约需几分钟，评估通过后，可点击“前往融资”，进入申请融资流程。';
    };
    const toUrl = (url) => {
      state.dialogVisible = true;
      state.financingUrl = url;
      state.dialogType = 'financing';
      state.dialogMsg =
        '页面即将跳转至第三方银行服务平台，腾讯公司不会对该平台上的个人信息进行处理。本平台仅提供技术服务，具体融资服务均由第三方银行提供，融资服务的合法性、真实性、准确性均由第三方银行负责，请您基于第三方银行提供的信息审慎判断并选择是否在银行开通融资信贷服务。';
    };
    const dialogConfirm = async (type) => {
      if (type === 'apply') {
        const res = await request('dataFinancing', 'financeInterfaceApply', {
          socialCreditCode: (state.dataList as any).socialCreditCode,
          bankCode: (state.applyInfos[state.checkedBank] as any).bankCode,
        });
        if (res.code === 2000) {
          state.dialogVisible = false;
          state.dialogType = '';
          state.dialogMsg = '';
          location.reload();
        }
      } else if (type === 'financing') {
        state.dialogVisible = false;
        state.dialogType = '';
        state.dialogMsg = '';
        window.open(state.financingUrl);
      }
    };
    onMounted(init);
    return {
      ...toRefs(state),
      userInfor,
      applySubmit,
      toUrl,
      valueToLabel,
      dialogConfirm,
      createQrcode,
      statusToColor,
    };
  },
});
